module.exports = __webpack_public_path__ + "static/media/ic-instant-book-color.3595a06e.svg";